import React, { useEffect, useState } from 'react';
import './login.css';
import axios from "axios";
import BaseUrl from '../../base-api';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import { saveAs } from 'file-saver';
import Loader from "../Loader/Loader";
const Login = () => {
  const [data, setData] = useState({
    mobile: '',
    post:'',
    captcha: ''
  });
  const [loading, setLoading] = useState(false);
  const [img, setImg] = useState("");

  useEffect(() => {
    fetchData();
  }, []);




  const handleChange = (e) => {
    let { name, value } = e.target;

    if (name === "mobile") {
      value = value.replace(/\D/g, "");
      if (value.length > 10) value = value.slice(0, 10);
    } else if (name === "captcha") {
      value = value.replace(/[^a-zA-Z0-9]/g, "");
      if (value.length > 6) value = value.slice(0, 6);
    }

    setData({ ...data, [name]: value });
  };
  const fetchData = async () => {
    setLoading(true);
    try {
      const jsessionid = Cookies.get('JSESSIONID');
      const res = await axios.get(`${BaseUrl}/api/auth/captcha`, {
        headers: {
          'Content-Type': 'application/json',
          ...(jsessionid && { Cookie: `JSESSIONID=${jsessionid}` }),
        },
        withCredentials: true,
      });

      if (res) {
        setImg(`data:image/png;base64,${res.data}`)

      }

    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
    }
    finally {
      setLoading(false);
    }
  };
  const handleSubmit = async (e) => {
    try {
      setLoading(true);
      const formData = {
        username: data.mobile,
        post:data.post,
        captcha: data.captcha,
      };
      const jsessionid = Cookies.get('JSESSIONID');
      const res = await axios.post(`${BaseUrl}/api/auth/download`, formData, {
        headers: {
          'Content-Type': 'application/json',
          ...(jsessionid && { Cookie: `JSESSIONID=${jsessionid}` }),
        },
        withCredentials: true,
        responseType: 'blob', 
      });
  
      if (res && res.data) {
        const blob = new Blob([res.data], { type: 'application/pdf' });
        saveAs(blob, 'admit_card.pdf'); 
      }
    } catch (error) {
      console.error('Download error:', error);
      toast.error(error.response?.data?.message || 'You are not eligible for this post.');
    } finally {
      setLoading(false);
      fetchData();
    } 
  }


  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="loginDiv">
          <div
            className="login-container"
            style={{
              boxShadow:
                "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
              borderRadius: "8px",
            }}
          >
            <h2 style={{ color: "grey" }}>Download Admit Card</h2>
            <form autoComplete='off'>
              <div className="form-group">
                <label>Mobile Number:</label>

                <input className='form-control'
                  type="text"
                  name="mobile"
                  value={data.mobile}
                  onChange={handleChange}
                  placeholder="Enter your Mobile Number" 
                  onPaste={(e) => e.preventDefault()}
                />
              </div>
              <div className="form-group">
                <label>Post:</label>

                <select name="post" value={data.post} onChange={handleChange} className='form-select'>
                  <option value="">Select Post</option>
                  <option value="office assistant">Office Assistant</option>
                  <option value="clerk">Clerk</option>
                  </select>
              </div>
              <img width={160} src={img} />
              <div className="form-group">
                <label>Enter Captcha:</label>
                <input className='form-control'
                  type="text"
                  name="captcha"
                  value={data.captcha}
                  onChange={handleChange}
                  placeholder="Enter above Captcha"
                  onPaste={(e) => e.preventDefault()}
                />
              </div>

              <button type="button" onClick={handleSubmit}>
                Verify
              </button>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default Login;
